import { render } from "./classificationEdit.vue?vue&type=template&id=95560ad8&scoped=true"
import script from "./classificationEdit.vue?vue&type=script&lang=js"
export * from "./classificationEdit.vue?vue&type=script&lang=js"

import "./classificationEdit.vue?vue&type=style&index=0&id=95560ad8&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95560ad8"]])

export default __exports__